<template>
  <cf-validated-form
    name="ageVerificationModal"
    @valid-submit="submitHandler"
  >
    <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
      <Teleport
        defer
        to="#portal-modal-header-target"
      >
        {{ content.AgeGate.title }}
      </Teleport>

      <p class="cf-subtitle cf-subtitle--2">
        {{ content.AgeGate.description }}
      </p>

      <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
        Please Confirm:
      </p>

      <checkbox-input
        v-model="isOver21"
        class="cf-checkbox-input--inline-center"
        name="isOver21"
        :validations="{ required: true }"
      >
        <p class="cf-subtitle cf-subtitle--2">{{ content.AgeGate.metadata.confirmationCheckboxLabel }}</p>
      </checkbox-input>

      <button
        v-if="required"
        :class="['cf-button cf-button--primary cf-button--lg', { 'cf-button--disabled': !isOver21 }]"
        type="submit"
        :disabled="!isOver21"
      >
        Proceed to Ordering
      </button>

      <template v-else>
        <button
          class="cf-button cf-button--primary cf-button--lg"
          type="submit"
          :disabled="!isOver21"
        >
          Proceed
        </button>

        <button
          class="cf-button cf-button--secondary cf-button--lg"
          type="button"
          @click="closeModalHandler"
        >
          Never Mind
        </button>
      </template>
    </div>
  </cf-validated-form>
</template>


<script>
  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';

  import { mapGetters } from 'vuex';


  export default {
    name: 'AgeVerification',

    components: {
      CfValidatedForm
    },

    props: {
      required: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isOver21: false
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('content', ['content'])
    },

    methods: {
      submitHandler() {
        this.$store.dispatch('session/updateHasVerifiedAgeForAlcohol', true);

        this.closeModalHandler();

        this.$emit('confirmed');
      },

      closeModalHandler() {
        this.$closeModal('ageVerificationModal');
      }
    }
  };
</script>
